export default __webpack_public_path__ + "static/media/global.3feb3d40.svg";